"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.undo = void 0;
exports.undo = {
    path: "M9.22082 1.08333C7.01249 1.08333 5.01249 1.90833 3.47082 3.25L0.470825 0.25V7.75H7.97082L4.95416 4.73333C6.11249 3.76667 7.58749 3.16667 9.22082 3.16667C12.1708 3.16667 14.6792 5.09167 15.5542 7.75L17.5292 7.1C16.3708 3.60833 13.0958 1.08333 9.22082 1.08333Z",
    originalWidth: 18,
    originalHeight: 8,
    basicColor: "tableGray1",
    activeColor: "tableBlack2",
};
